if (!customElements.get('fablair-comparison')) {
  customElements.define('fablair-comparison', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.range = this.querySelector('input[type="range"]');
      if (!this.range) return;
      this.range.disabled = false;
      const hint = this.querySelector('.fc-section__help');
      if (hint) hint.hidden = false;
      this.range.addEventListener('input', () => this.update(), { signal: this.abortController.signal });
      this.update();
    }
    update() {
      const value = Math.max(0, Math.min(100, Number(this.range.value)));
      this.style.setProperty('--fc-position', `${value}%`);
      this.range.setAttribute('aria-valuetext', `${this.dataset.beforeLabel}: %${value}, ${this.dataset.afterLabel}: %${100 - value}`);
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
